<template>
  <div class="pa-5 pt-2">
    <v-row>
      <v-col cols="12">
        <creator-concept-data-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CreatorConceptDataTable from './DataTable'
export default {
  name: 'creator-concept',
  components: {
    CreatorConceptDataTable
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?8bd803aa